<template
  ><b-container fluid>
    <b-row>
      <b-col class="top_bar" />
    </b-row>
    <b-row
      ><b-col><div class="page_title">Score Reports</div></b-col></b-row
    >
    <b-row class="padding mb-3">
      <b-col>
        <b-button class="tsny_button" @click="scoreExam">+ Score Exam</b-button>
      </b-col>
    </b-row>
    <b-row
      class="page_indentation mb-4"
      v-for="(scoreReport, index) in scoreReports"
      :key="index"
    >
      <score-report-overview
        :score-report="scoreReport"
        @delete-report="deleteReportHandler(index)"
      />
    </b-row>
    <select-exam-modal />
    <delete-score-report-modal
      :relationship-id="selectedCourseRelationship"
      :report-id="selectedScoreReport"/></b-container
></template>

<script>
import StoreConstants from "../../store/services/StoreConstants";
import { mapGetters } from "vuex";
import ScoreReportOverview from "../../components/ScoreReports/ScoreReportOverview";
import DeleteScoreReportModal from "../../components/ScoreReports/DeleteScoreReportModal";
import SelectExamModal from "../../components/ScoreReports/SelectExamModal";

export default {
  name: "ScoreReports",
  components: {
    SelectExamModal,
    DeleteScoreReportModal,
    ScoreReportOverview
  },
  computed: {
    ...mapGetters({
      courseRelationships: StoreConstants.GETTERS.COURSES
    }),
    scoreReports() {
      let scoreReports = [];
      for (let i = 0; i < this.courseRelationships.length; i++) {
        let relationship = this.courseRelationships[i];
        for (let j = 0; j < relationship.scoreReports.length; j++) {
          let scoreReport = relationship.scoreReports[j];
          scoreReport.courseRelationshipId = relationship._id;
          scoreReport.courseId = relationship.courseId;
          scoreReport.color = relationship.color;
          scoreReports.push(scoreReport);
        }
      }
      return scoreReports;
    }
  },
  data: () => ({
    selectedCourseRelationship: null,
    selectedScoreReport: null
  }),
  methods: {
    scoreExam() {
      this.$bvModal.show("selectExamModal");
    },
    deleteReportHandler(index) {
      let report = this.scoreReports[index];
      this.selectedIndex = index;
      this.selectedCourseRelationship = report.courseRelationshipId;
      this.selectedScoreReport = report._id;
      this.$bvModal.show("deleteScoreReportModal");
    }
  }
};
</script>

<style scoped>
.padding {
  padding-left: 45px;
  padding-right: 45px;
}
</style>
